import {observer} from 'mobx-react-lite'
import React, {useMemo} from 'react'
import {DataObjectId} from 'yougile-model'
import {RowContent} from '@components/common/sandbox/list-view/types'
import {
  TaskStore,
  TaskStoreContext
} from '@components/my-tasks/tasks-list/task-store'
import {useSyncEvent} from '@containers/hooks'
import {useLoadedLazyTaskEffect} from '@containers/hooks'

/**
 * Smart component that provides task store to the whole row and listen for user events
 * @param taskId
 * @param children
 * @constructor
 */
export const TaskRow = observer(
  ({taskId, children}: {taskId: DataObjectId; children: RowContent}) => {
    const store = useMemo(() => new TaskStore(taskId), [taskId])

    /**
     * Sync task data on current event
     */
    useSyncEvent(
      'current',
      {filter: taskId},
      () => {
        store.syncTaskData()
      },
      [taskId]
    )

    useLoadedLazyTaskEffect(store.taskHub, 'task-name-column')

    return (
      <>
        <TaskStoreContext.Provider value={store}>
          {children}
        </TaskStoreContext.Provider>
      </>
    )
  }
)
